/**
 * trackGTM will push events into the dataLayer so that they can be picked up by.
 * our GTM container.
 *
 * @param  Object Should contain keys for eventName and eventLabel (if applicable)
 */
export function trackGTM({ event = '', ...attributes }) {
  if (!window.dataLayer || !event) {
    return;
  }

  // pass other attributes if they exist
  const data = {
    event,
    ...(attributes && { ...attributes }),
  };

  window.dataLayer.push(data);
}
